import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
/**
* @public
*/
const UlistIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsxs("svg", {
		"data-sanity-icon": "ulist",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: [
			/* @__PURE__ */ jsx("path", {
				d: "M7.10153 17.5C7.10153 17.8322 6.83221 18.1016 6.5 18.1016C6.16778 18.1016 5.89847 17.8322 5.89847 17.5C5.89847 17.1678 6.16778 16.8985 6.5 16.8985C6.83221 16.8985 7.10153 17.1678 7.10153 17.5Z",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M7.10153 7.49997C7.10153 7.83218 6.83221 8.1015 6.5 8.1015C6.16778 8.1015 5.89847 7.83218 5.89847 7.49997C5.89847 7.16775 6.16778 6.89844 6.5 6.89844C6.83221 6.89844 7.10153 7.16775 7.10153 7.49997Z",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M7.10153 12.5C7.10153 12.8322 6.83221 13.1015 6.5 13.1015C6.16778 13.1015 5.89847 12.8322 5.89847 12.5C5.89847 12.1678 6.16778 11.8984 6.5 11.8984C6.83221 11.8984 7.10153 12.1678 7.10153 12.5Z",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M10 7.5H19M10 17.5H19M10 12.5H19",
				stroke: "currentColor",
				strokeWidth: 1.2,
				strokeLinejoin: "round"
			})
		]
	});
});
export { UlistIcon, UlistIcon as default };

//# sourceMappingURL=Ulist.js.map